goog.provide('el8.uid');

el8.uid.getUid = function(obj) {
    if (obj) {
        return obj[el8.uid._UID_PROPERTY] ||
            (obj[el8.uid._UID_PROPERTY] = ++el8.uid._counter);
    }
    return null;
};
el8.uid._counter = 0;
el8.uid._UID_PROPERTY = 'el8_id_'+Math.floor(Math.random()*21483043).toString(36);
